<template>
  <v-card flat :loading="loading">
    <v-card-title>
      <v-btn @click="openAdd = true" class="btn-send-sms">
        <v-icon left>mdi-plus</v-icon>
        افزودن دامنه
      </v-btn>
    </v-card-title>

    <v-card-text>
      <data-table :data="data" :columns="columns" :translate="translates" />
    </v-card-text>

    <custom-popup v-model="openAdd" :cons="cons" max-width="500">
      <v-card flat>
        <v-card-title class="text-break">
          لطفا آدرس دامنه را وارد نمایید
        </v-card-title>
        <v-card-subtitle>
          در نظر داشته باشید ابتدا میبایست DNS های سرور را تنظیم نمایید!
        </v-card-subtitle>

        <v-card-text>
          <v-text-field
            v-model="domainUrl"
            @keydown.enter="addNewDomain"
            outlined
            dense
            append-icon="mdi-web"
            clearable
            clear-icon="mdi-close-circle-outline"
            :loading="loading"
            :error-messages="errors.name"
            :rules="urlRules"
          />
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn
            @click="addNewDomain"
            color="success"
            depressed
            :loading="loading"
            :disabled="!allowToAdd"
          >
            <v-icon left>mdi-plus</v-icon>
            افزودن دامنه
          </v-btn>
        </v-card-actions>
      </v-card>
    </custom-popup>
  </v-card>
</template>

<script>
import domainButtons from "./components/domainButtons";

export default {
  name: "domains",

  components: {
    domainButtons,
  },

  data() {
    return {
      data: {},
      loading: false,
      openAdd: false,
      domainUrl: "",
      cons: {
        title: "افزودن دامنه",
        buttons: [
          {
            type: "submit",
            handler: this.addNewDomain,
            disabled: () => !this.allowToAdd,
          },
        ],
      },
      urlRules: [
        (value) =>
          this.isDomain(value) ||
          "دامنه سایت باید بصورت https://terminalads.com یا terminalads.com وارد شود. ",
      ],
      errors: {},
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "asc",
      },
      columns: [
        {
          label: "ID",
          name: "id",
          orderable: true,
        },
        {
          label: "دامنه",
          name: "name",
          orderable: true,
        },
        {
          label: "user ID",
          name: "user_id",
          transform: (val) => {
            return val.data.user_id ?? "--";
          },
        },
        {
          label: "وضعیت",
          name: "status",
          transform: (val) => {
            return val.data.status === "active" ? "فعال" : "غیرفعال";
          },
        },
        {
          label: "عملیات",
          name: "actions",
          component: domainButtons,
          handler: this.actions,
          event: "click",
        },
      ],
    };
  },

  mounted() {
    this.fetch();
  },

  computed: {
    translates() {
      return {
        nextButton: "بعدی",
        previousButton: "قبلی",
        rowsPerPageText: "تعداد در صفحه",
        noDataText: "داده ای برای نمایش وجود ندارد",
        placeholderSearch: "جستجو",
      };
    },
    allowToAdd() {
      return (
        this.domainUrl &&
        this.domainUrl.length > 0 &&
        this.isDomain(this.domainUrl)
      );
    },
  },

  methods: {
    fetch(options = this.tableProps) {
      this.loading = true;

      this.$api
        .get("/admin/domain", {
          params: options,
        })
        .then(({ data }) => {
          this.data = data;
        })
        .catch((errors) => {})
        .finally(() => (this.loading = false));
    },
    isDomain(str) {
      var regex = new RegExp(
        "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?",
      );
      var without_regex = new RegExp(
        "^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?",
      );
      if (
        !str ||
        regex.test(str) ||
        without_regex.test(str) ||
        str.length <= 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    addNewDomain() {
      if (!this.allowToAdd)
        return this.$toast.error("دامنه وارد شده صحیح نمی باشد!");

      this.loading = true;
      this.errors = {};

      this.$api
        .post("/admin/domain", {
          name: this.domainUrl,
        })
        .then(({ data }) => {
          this.$toast.success("دامنه شما با موفقیت افزوده شد");
          this.openAdd = false;
          this.fetch();
        })
        .catch(({ response }) => {
          if (response.data?.errors) {
            this.errors = response.data.errors;
          }
          if (response.data?.message) {
            this.$toast.error(response.data.message);
          }
        })
        .finally(() => {
          this.loading = false;
          this.domainUrl = "";
        });
    },
    actions(data, type) {
      this[type](data);
    },
    destroy(data) {
      this.loading = true;

      this.$api
        .delete(`/admin/domain/${data.id}`)
        .then(({ data }) => {
          this.$toast.success("با موفقیت حذف شد.");
          this.fetch();
        })
        .catch(({ response }) =>
          console.log("error in delete domain: ", response),
        )
        .finally(() => (this.loading = false));
    },
    updateStatus(data) {
      this.loading = true;

      this.$api
        .put(`/admin/domain/${data.id}`, {
          name: data.name,
          status: data.status === "active" ? "deactivate" : "active",
        })
        .then(({ data }) => {
          this.$toast.success("با موفقیت تغییر یافت.");
          this.fetch();
        })
        .catch(({ response }) => {
          this.$toast.error("خطا در انجام عملیات تغییر وضعیت");
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped></style>
